export const breakfastItem = [
  {
    title: "Štrafta doručak",
    subtitle: "350g",
    description: "Jaja, tost, avokado, pršuta, pohovani kačkavalj",
    price: "6,50€",
    isFirst: true,
  },
  {
    title: "Benedikt jaja slanina",
    subtitle: "350g",
    description: "poširana jaja, tost, gvakamole sos, holandez sos",
    price: "5,50€",
  },
  {
    title: "Benedikt jaja pršuta",
    subtitle: "350g",
    description: "poširana jaja, tost, gvakamole sos, holandez sos",
    price: "6,00€",
  },
  {
    title: "Benedikt jaja losos",
    subtitle: "350g",
    description: "poširana jaja, tost, gvakamole sos, holandez sos",
    price: "6,50€",
  },
  {
    title: "Omlet sa šunkom i sirom",
    subtitle: "300g",
    description: "jaja, šunka, trapist , pavlaka",
    price: "4,50€",
  },
  {
    title: "Omlet sa povrćem",
    subtitle: "300g",
    description: "jaja, trapist, povrće",
    price: "4,20€",
  },
  {
    title: "Sport doručak",
    subtitle: "300g",
    description: "bjelanca, tikvica, losos, pavlaka",
    price: "6,70€",
  },
  {
    title: "Engleski doručak",
    subtitle: "300g",
    description: "3 jaja, 2 kobasice, feta",
    price: "5,50€",
  },
  {
    title: "Puter kiflice",
    subtitle: "250g",
    description: "sir, pršut, trapist, tartar sos",
    price: "5,00€",
  },
  {
    title: "Punjene prženice",
    subtitle: "300g",
    description: "trapist, šunka",
    price: "5,00€",
  },
   {
    title: "Omlet na čabati",
    subtitle: "350g",
    description: "3 jaja, feta sir, spanać, čabata",
    price: "7,00€",
    isNew: true,

  },
   {
    title: "Beef doručak",
    subtitle: "350g",
    description: "3 jaja, teletina, mocarela, salata, sos",
    price: "8,60€",
    isNew: true,

  },
];

export const StratersItems = [
  {
    title: "Starters Štrafta",
    subtitle: "500g",
    description:
      "svinjski i govedji pršut, kulen, gorgonzola, mocarela, parmezan, badem, feta, masline, čeri, fokaća",
    price: "14,00€",
    isFirst: true,
  },
   {
    title: "Punjene pečurke",
    subtitle: "250g",
    description: "pečurke, riža, sir, pršut",
    price: "6,50€",
  },
  {
    title: "Selekcija sireva",
    subtitle: "450g",
    description:
      "gorgonzola, mocarela, gauda, feta, parmezan, masline, indijski orah, čeri",
    price: "12,50€",
  },
  {
    title: "Pohovani kačkavalj",
    subtitle: "350g",
    description: "sir, pomfrit, tartar sos",
    price: "5,50€",
  },
  {
    title: "Brusketi",
    subtitle: "200g",
    description: "mocarela, paradajz, masline",
    price: "5,00€",
  },
  { title: "Grilovano povrće", subtitle: "250g", price: "5,00€" },
 
];

export const SoupsItems = [
  { title: "Teleća čorba", price: "4,00€", isFirst: true },
  { title: "Minestrone", price: "3,50€" },
  { title: "Potaž od paradajza", price: "4,00€" },
];

export const salatItems = [
  { section: "Obrok salate" },
  {
    title: "Ala Chef",
    subtitle: "400g",
    description: "salata, piletina, pečurke, dimljeni sir, šunka, dresing",
    price: "8,50€",
    isFirst: true,
  },
  {
    title: "Biftek salata",
    subtitle: "400g",
    description:
      "miks salata, dresing, biftek, mocarela, badem, krutoni, parmezan",
    price: "9,50€",
  },
  {
    title: "Štrafta salata",
    subtitle: "400g",
    description:
      "miks salata, dresing, pohovana feta, hrskava piletina, indijski orah,krutoni, parmezan",
    price: "8,50€",
  },
  {
    title: "Cezar salata",
    subtitle: "400g",
    description:
      "miks salata, dresing, mocarela, piletina, slanina, krutoni,badem parmezan",
    price: "8,30€",
  },
  {
    title: "Losos salata",
    subtitle: "400g",
    description:
      "miks salata, dresing, avokado, dimljeni losos, sjemenke bundeve",
    price: "8,80€",
  },
  {
    title: "Caprese salata",
    subtitle: "250g",
    description: "mocarela, paradajz, pesto sos, bosiljak",
    price: "6,00€",
  },
  { section: "Sezonske salate" },
  { title: "Šopska salata", subtitle: "250g", price: "4,00€", isFirst: true },
  { title: "Mix salata", subtitle: "250g", price: "3,50€" },
  { title: "Paradajz salata", subtitle: "250g", price: "3,00€" },
];
export const mainDishes = [
  {
    title: "Biftek na žaru",
    subtitle: "400g",
    description: "biftek, pire od tartufa",
    price: "22,00€",
    isFirst: true,
  },
  {
    title: "Biftek u ulju",
    subtitle: "400g",
    description: "biftek, pire",
    price: "24,00€",
  },
  {
    title: "Biftek u sosu",
    description: "-gorgonzole  -pečuraka   -4 vrste sira   -pomorandže",
    price: "23,00€",
  },
  {
    title: "Teleći medaljoni",
    subtitle: "400g",
    description: "teleće meso, neutralna pavlaka, pečurke, aromatični krompir",
    price: "19,00€",
  },
  {
    title: "Ramstek",
    subtitle: "450g",
    description: "Teleće meso, pirinač, povrće",
    price: "17,00€",
  },
  {
    title: "Vok Šangaj",
    subtitle: "500g",
    description: "3 vrste mesa, nudle, miks povrća, kikiriki, susam",
    price: "11,50€",
  },
  {
    title: "Štapići na kajmaku",
    subtitle: "350g",
    description: "piletina, kajmak, lepinja/svinjski vrat, kajmak, lepinja",
    price: "8,00€",
  },
  {
    title: "Piletina u kari sosu",
    subtitle: "350g",
    description: "pileći file, kari sos, pirinač",
    price: "8,50€",
  },
  {
    title: "Hrskava piletina",
    subtitle: "350g",
    description: "piletina,  kroketi, tartar sos, kornifleks",
    price: "9,00€",
  },
  {
    title: "Ražnjići",
    subtitle: "400g",
    description: "Piletina, pančeta, paprika, pomfrit",
    price: "8,70€",
  },
  {
    title: "Piletina u gorgonzoli",
    subtitle: "350g",
    description: "piletina, pirinač, pomfrit, gorgonzola, neutralna pavlaka",
    price: "9,00€",
  },
  {
    title: "Piletina u sosu od spanaća",
    subtitle: "350g",
    description: "piletina, spanać, pomfrit, neutralna pavlaka",
    price: "9,00€",
  },
  {
    title: "Piletina sa susamom i bademom",
    subtitle: "350g",
    description: "piletina, neutrala pavlaka, susam, badem",
    price: "9,00€",
  },
  {
    title: "Piletina u kikiriki sosu",
    subtitle: "350g",
    description: "piletina, neutralna pavlaka, puter od kikirikija",
    price: "8,80€",
  },
  {
    title: "Šefova piletina",
    subtitle: "350g",
    description: "rolovana piletina, sir, pršut, aromatični krompir, sos od pečuraka",
    price: "9,80€",
    isNew: true,

  },
  
];

export const tortillasItems = [
  { section: "Sendviči"},
  {
    title: "Sendvič Sicilija",
    subtitle: "300g",
    description: "Lepinja, namaz, pršuta, sir, salata, pomfrit",
    price: "5,80€",
    isFirst: true,
  },
  {
    title: "Pizza sendvič",
    subtitle: "350g",
    description: "lepinja, namaz, pršuta, pomfrit",
    price: "5,50€",
  },
  {
    title: "Rich sendvič",
    subtitle: "300g",
    description: "lepinja, trapist, pohovana piletina, pomfrit",
    price: "6,50€",
  },
  {
    title: "Klub sendvič",
    subtitle: "350g",
    description: "tost, piletina, jaje, šunka, trapist, pomfrit",
    price: "5,50€",
  },
  {
    title: "Beef sendvič",
    subtitle: "350g",
    description: "čabata, teletina, mocarela, sos, pomfrit",
    price: "8,90€",
    isNew: true,

  },
  { section: "TORTILJE" },
  {
    title: "Tortilja u cary sosu",
    subtitle: "450g",
    description:
      "domaća tortilja, piletina, neutralna pavlaka, zelena salata paradajz, pomfrit",
    price: "6.50€",
    isFirst: true,
  },
  {
    title: "Tortilja u pesto sosu",
    subtitle: "450g",
    description: "domaća tortilja, sir, piletina, salata, pesto sos, pomfrit",
    price: "6,20€",
  },
  {
    title: "Tortilja piletina i gvakamole",
    subtitle: "450g",
    description: "domaća tortilja, gvakamole sos, piletina, salata, pomfrit",
    price: "6,50€",
  },
  {
    title: "Beef tortilja",
    subtitle: "450g",
    description: "domaća tortilja, teletina, sos, salata, pomfrit",
    price: "8,20€",
    isNew: true,

  },
  {
    title: "CHEDAR TORTILJA",
    subtitle: "450g",
    description: "domaća tortilja, čedar sir, piletina, salata, sos, pomfrit",
    price: "7,20€",
    isNew: true,

  },
];

export const pizze = [
  {
    title: "Ala Chef",
    description: "pelat, sir, pršuta, šunka, pančeta, kulen, pečurke, kajmak",
    prices: [
     
      {
        size: "350g",
        price: "6,10€",
      },
       {
        size: "600g",
        price: "9,20€",
      },
    ],
    isFirst: true,
  },
  {
    title: "Margarita",
    description: "sir, pelat, bosiljak",
    prices: [
     
      {
        size: "280g",
        price: "4,50€",
      },
       {
        size: "550g",
        price: "6,50€",
      },
    ],
  },
  {
    title: "Capricosa",
    description: "pelat, sir, šunka, pečurke",
    prices: [
      
      {
        size: "300g",
        price: "5,50€",
      },
      {
        size: "600g",
        price: "7,50€",
      },
    ],
  },
  {
    title: "Pepperoni",
    description: "pelat, sir, kulen, ljuta paprika",
    prices: [
      
      {
        size: "300g",
        price: "6,00€",
      },
      {
        size: "500g",
        price: "8,00€",
      },
    ],
  },
  {
    title: "Tonno",
    description: "pelat, sir, tunjevina, luk",
    prices: [
      
      {
        size: "350g",
        price: "5,00€",
      },
      {
        size: "600g",
        price: "6,80€",
      },
    ],
  },
  {
    title: "Toscana",
    description: "pelat, sir, pršuta, gorgonzola, rukola",
    prices: [
      
      {
        size: "300g",
        price: "6,00€",
      },
      {
        size: "550g",
        price: "8,00€",
      },
    ],
  },
  {
    title: "Quatro formagi",
    description: "pelat, gauda, gorgonzola, mocarela, parmeza",
    prices: [
      
      {
        size: "300g",
        price: "5,50€",
      },
      {
        size: "500g",
        price: "7,50€",
      },
    ],
  },
  {
    title: "Vegeteriana",
    description: "pelat, sir, povrće",
    prices: [
      
      {
        size: "350g",
        price: "5,00€",
      },
      {
        size: "600g",
        price: "6,60€",
      },
    ],
  },
  {
    title: "Calcone",
    prices: [
      
      {
        size: "350g",
        price: "5,50€",
      },
      {
        size: "500g",
        price: "7,50€",
      },
    ],
  },
];

export const pastaAndRisoto = [
  { section: "Pasta" },
  {
    title: "Ala Chef pasta",
    subtitle: "400g",
    description: "piletina, pečurke,tikvice, neutralna pavlaka",
    price: "8,00€",
    isFirst: true,
  },
  {
    title: "Pasta ai frutti di mare",
    subtitle: "400g",
    description: "morski plodovi, pasta, crveni sos",
    price: "8,70€",
  },
  {
    title: "Tagliatelle carbonara",
    subtitle: "400g",
    description: "slanina, pavlaka neutralna, parmezan, jaje",
    price: "7,50€",
  },
  {
    title: "Spaghetti Pollo e Pesto",
    subtitle: "400g",
    description: "piletina, neutralna pavlaka, pesto sos, indijski orah",
    price: "8,00€",
  },
  {
    title: "Njoke Formaggio e Pollo",
    subtitle: "400g",
    description: "piletina, 4 vrste sira, badem, njoke",
    price: "8,00€",
  },
  {
    title: "Farfalle Vittelo e Fungi",
    subtitle: "400g",
    description: "biftek, neutralna pavlaka, pečurke, soya sos, parmezan",
    price: "9,90€",
  },
  {
    title: "Tagliatelle di tacchino arrosto",
    subtitle: "400g",
    description: "pečurke, piletina, neutralna pavlaka, mocarela",
    price: "8,20€",
  },
  { section: "Rižoto" },
  {
    title: "Risotto Formagio e Pollo",
    subtitle: "400g",
    description: "piletina, 4 vrste sira, neutralna pavlaka, parmezan",
    price: "8,00€",
    isFirst: true,
  },
  {
    title: "Risotto tacchino e Pesto",
    subtitle: "400g",
    description: "piletina, pesto sos, neutralna pavlaka, parmezan",
    price: "7,50€",
  },
  {
    title: "Risotto Vittelo e Fung",
    subtitle: "400g",
    description: "biftek, sos od pečurki, neutralna pavlaka, riža",
    price: "9,50€",
  },
  {
    title: "Risotto nero ai frutti di mare",
    subtitle: "400g",
    description: "crnilo od sipe, morski plodovi, riža",
    price: "8,50€",
  },
  {
    title: "Risotto Rosso ai frutti di mare",
    subtitle: "400g",
    description: "crveni sos, morski plodovi, riža",
    price: "8,50€",
  },
   {
    title: "Arabiata pasta",
    subtitle: "400g",
    description: "pasta, paprika, pelat, čili",
    price: "7,00€",
  },
];

export const fishItems = [
  {
    title: "Losos na žaru",
    subtitle: "350g",
    description: "Losos, mediteransko varivo",
    price: "16,00€",
    isFirst: true,
  },
  {
    title: "Tuna stek",
    subtitle: "350g",
    description: "tuna, mediteransko varivo",
    price: "20,00€",
  },
  {
    title: "Lignje na žaru",
    subtitle: "350g",
    description: "lignje, dalmatinsko varivo",
    price: "15,00€",
  },
];

export const sidedishesItems = [
  {
    title: "Pomfrit",
    subtitle: "300g",
    price: "3,00€",
    isFirst: true,
  },
  {
    title: "Ekstra prilog",
    price: "1,50€",
  },
  {
    title: "Masline",
    subtitle: "100g",
    price: "1,00€",
  },
  {
    title: "Pica hljeb",
    subtitle: "100g",
    price: "1,60€",
  },
  {
    title: "Fokaća",
    subtitle: "200g",
    price: "3,00€",
  },
  {
    title: "Sos po želji",
    price: "2,00€",
  },
  {
    title: "Kajmak",
    price: "3,80€",
  },
  {
    title: "Pršuta",
    subtitle: "100g",
    price: "4,20€",
  },
];

export const dessertItems = [
  {
    title: "Palačinka",
    subtitle: "250g",
    description: "nutela, plazma",
    price: "3,50€",
    isFirst: true,
  },
  {
    title: "Američke palačinke",
    subtitle: "250g",
    description: "eurokrem, plazma",
    price: "4,00€",
  },
  {
    title: "Američke palačinke",
    subtitle: "250g",
    description: "banana i badem",
    price: "4,50€",
  },
  {
    title: "Američke palačinke sa nutelom",
    subtitle: "250g",
    price: "4,00€",
  },
  {
    title: "Američke palačinke sa voćem",
    subtitle: "250g",
    description: "eurokrem, voće, šlag",
    price: "4,50€",
  },
  {
    title: "Palačinke u kremu od pistaća",
    subtitle: "250g",
    description: "nutela, plazma, pistaći, krem",
    price: "6,00€",
  },
  {
    title: "Palačinke u rafaelo kremu",
    subtitle: "250g",
    description: "bijela čokolada, kranči",
    price: "5,50€",
  },
  {
    title: "Fransh cake",
    description: "nutela, lješnik",
    price: "3,90€",
  },
  {
    title: "Tiramisu pistaći",
    description: "piškote, krema od pistaća",
    price: "3,70€",
  },
  {
    title: "Jagode sa šlagom",
    price: "4,50€",
  },
  {
    title: "Voćna salata",
    price: "4,80€",
  },
  {
    title: "Sladoled kugla",
    price: "1,50€",
  },
];


export type FastingMenuItem = {
  title: string;
  subtitle?: string;
  description?: string;
  price?: string;
  prices?: {
    size: string;
    price: string;
  }[];
  isFirst?: boolean;
};

export const fastingMenuItems: FastingMenuItem[] = [
  {
    title: "LOSOS SALATA",
    subtitle: "/400g",
    description:
      "Mix salata, dressing, avocado, dimljeni losos, sjemenke bundeve",
    price: "8,80€",
    isFirst: true,
  },
  {
    title: "PASTA AI FRUTTI DI MARE",
    subtitle: "/400g",
    description: "Morski plodovi, pasta, crveni sos",
    price: "8,70€",
  },
  {
    title: "RISOTTO NERO AI FRUTTI DI MARE",
    subtitle: "/400g",
    description: "Crnilo od sipe, morski plodovi, riža",
    price: "8,50€",
  },
  {
    title: "RISOTTO ROSSO AI FRUTTI DI MARE",
    subtitle: "/400g",
    description: "Crveni sos, morski plodovi, riža",
    price: "8,50€",
  },
  {
    title: "LOSOS NA ŽARU",
    subtitle: "/350g",
    description: "Losos, dalmatinsko varivo",
    price: "16,00€",
  },
  {
    title: "TUNA STEK",
    subtitle: "/350g",
    description: "Dalmatinsko varivo",
    price: "20,00€",
  },
  {
    title: "BRUSKETI SA LOSOSOM",
    subtitle: "/300g",
    description: "Dimljeni losos, posni namaz, masline, paradajz",
    price: "6,00€",
  },
  {
    title: "LIGNJE NA ŽARU",
    subtitle: "/350g",
    description: "Lignje, riža",
    price: "15,00€",
  },
  {
    title: "OVSENA KAŠA",
    subtitle: "/450g",
    description:
      "Ovsene pahuljice, chia sjemenke, mix voća, mix orašastih plodova, kikiriki puter",
    price: "5,00€",
  },
  {
    title: "PUTER KIFLICE",
    subtitle: "/300g",
    description: "Posni sir, pečurke",
    price: "5,00€",
  },
  {
    title: "GRILOVANE PEČURKE",
    subtitle: "/450g",
    description: "Pečurke, riža",
    price: "5,60€",
  },
  {
    title: "GRILOVANO POVRĆE",
    subtitle: "/300g",
    price: "5,00€",
  },
  {
    title: "MINESTRONE SUPA",
    subtitle: "/350ml",
    price: "3,50€",
  },
  {
    title: "POTAŽ OD PARADAJZA",
    subtitle: "/350ml",
    price: "4,00€",
  },
  {
    title: "PIZZA SENDVIČ",
    subtitle: "/350g",
    description:
      "Lepinja, namaz, tunjevina, zelena salata, paradajz, crveni luk",
    price: "5,50€",
  },
  {
    title: "PIZZA TONNO",
    description: "Tomato sauce, posni sir, tunjevina, luk",
    prices: [
      {
        size: "350g",
        price: "4,90€",
      },
      {
        size: "600g",
        price: "6,60€",
      },
    ],
  },
  {
    title: "PIZZA VEGETERIANA",
    description: "Tomato sauce, posni sir, povrće",
    prices: [
      {
        size: "350g",
        price: "4,60€",
      },
      {
        size: "600g",
        price: "6,40€",
      },
    ],
  },
  {
    title: "POSNA PALAČINKA",
    subtitle: "/350g",
    description: "Posni krem, miks voća",
    price: "4,50€",
  },
];


export type PremiumMenuItem = {
  section?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  price?: string;
  prices?: {
    size: string;
    price: string;
  }[];
  isFirst?: boolean;
};

export const premiumMenuItems: PremiumMenuItem[] = [
  {
    section: "DORUČAK",
  },
  {
    title: "ŠTRAFTA DORUČAK",
    subtitle: "/350g",
    description:
      "3 jaja, tost, avokado, pršuta, pohovani kačkavalj",
    price: "6,50€",
    isFirst: true,
  },
  {
    title: "Beef doručak",
    subtitle: "/350g",
    description:
      "3 jaja, teletina, mocarela, salata, sos",
    price: "8,60€",
  },

  {
    section: "SENDVIČI I TORTILJE",
  },
  {
    title: "Beef sendvič",
    subtitle: "/350g",
    description:
      "dimljena teletina, mocarela, sos, pomfrit",
    price: "8,90€",
    isFirst: true,
  },
  {
    title: "Beef tortilja",
    subtitle: "/450g",
    description:
      "domaća tortilja, teletina, sos, salata, pomfrit",
    price: "8,20€",
  },
  {
    title: "CHEDAR TORTILJA",
    subtitle: "/450g",
    description:
      "domaća tortilja, čedar sir, piletina, salata, sos, pomfrit",
    price: "6,50€",
  },

  {
    section: "PIZZE",
  },
  {
    title: "A'LA SHEF",
    description:
      "tomato sauce, sir, pršuta, šunka, pančeta, kulen, pečurke, kajmak",
    prices: [
      {
        size: "600g",
        price: "9,20€",
      },
      {
        size: "350g",
        price: "6,10€",
      },
    ],
    isFirst: true,
  },

  {
    section: "PASTE I RIŽOTA",
  },
  {
    title: "FARFALLE VITELLO E FUNGHI",
    subtitle: "/400g",
    description:
      "Biftek, neutralna pavlaka, pečurke, soja sos, parmezan",
    price: "9,90€",
    isFirst: true,
  },

  {
    section: "OBROK SALATE",
  },
  {
    title: "BIFTEK SALATA",
    subtitle: "/400g",
    description:
      "Mix salata, dressing, biftek, mocarela, badem, krutoni, parmezan",
    price: "9,50€",
    isFirst: true,
  },

  {
    section: "POTAŽI I SUPE",
  },
  {
    title: "POTAŽ OD PARADAJZA",
    subtitle: "/350ml",
    price: "4,00€",
    isFirst: true,
  },

  {
    section: "GLAVNA JELA",
  },
  {
    title: "Biftek u ulju",
    subtitle: "/400g",
    description:
      "maslinovo ulje, pesto, pire",
    price: "24,00€",
    isFirst: true,
  },
  {
    title: "Šefova piletina",
    subtitle: "/350g",
    description:
      "rolovana piletina, sir, pršuta, aromatični krompir, sos od pečuraka",
    price: "9,80€",
  },

  {
    section: "JELA OD RIBE",
  },
  {
    title: "TUNA STEK",
    subtitle: "/350g",
    description:
      "tuna, mediteransko varivo",
    price: "20,00€",
    isFirst: true,
  },

  {
    section: "DEZERTI",
  },
  {
    title: "FRENCH CAKE",
    description: "Nutella, hazelnut",
    price: "3,90€",
    isFirst: true,
  },

  {
    section: "VINA",
  },
  {
    title: "VRANAC RESERVE",
    subtitle: "/0,75l",
    price: "50,00€",
    isFirst: true,
  },
  {
    title: "NOTA",
    subtitle: "/0,75l",
    price: "45,00€",
  },
];